import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.2083 16.875H4.79167C3.87153 16.875 3.125 16.1285 3.125 15.2083V4.79167C3.125 3.87153 3.87153 3.125 4.79167 3.125H15.2083C16.1285 3.125 16.875 3.87153 16.875 4.79167V15.2083C16.875 16.1285 16.1285 16.875 15.2083 16.875Z"
          stroke="#7A8499"
          strokeMiterlimit="10"
        />
        <path d="M3.125 7.70898H16.6667" stroke="#7A8499" strokeMiterlimit="10" />
        <path
          d="M3.125 12.291H16.875"
          stroke="#7A8499"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.7085 16.8757V3.33398" stroke="#7A8499" strokeMiterlimit="10" />
      </svg>
    </>
  );
};
